import { render } from "./Hospedes.vue?vue&type=template&id=5f9f22ec&scoped=true"
import script from "./Hospedes.vue?vue&type=script&lang=js"
export * from "./Hospedes.vue?vue&type=script&lang=js"

import "./Hospedes.vue?vue&type=style&index=0&id=5f9f22ec&scoped=true&lang=scss"
import "./Hospedes.vue?vue&type=style&index=1&id=5f9f22ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9f22ec"]])

export default __exports__